"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const glightbox_1 = __importDefault(require("glightbox"));
require("glightbox/src/postcss/glightbox.css");
const lightbox = new glightbox_1.default({
    selector: '.glightbox',
    touchNavigation: true,
    loop: false,
    autoplayVideos: false,
    openEffect: 'zoom',
    closeEffect: 'zoom'
});
exports.default = {};
